<template>
<div class="row">
  
  <div class="col-12 mb-2" v-loading="config.loading.content">
    <ed-form :data="formData" :config="config" :itens="formItems" :response="response">
      <div slot="form-footer"></div>
    </ed-form>

    <div class="col-12 text-center">
      <ed-button
        icon="fa fa-times"
        type="danger"
        value="Prosseguir com o Calcelamento"
        @click="salvar"
      />
    </div>

  </div>

</div>
</template>

<script>
import Rest from 'common/rest'
import EdAlert from 'common/alert'
import EdForm from 'common/form'
import EdButton from 'common/button'
import FormItems from '../_form/consulta-config-cancelar'

export default {
    name: 'aso',
    components:{EdAlert,EdForm,EdButton},
    mixins:[Rest],
    props:{
      consulta:{
        type: Object,
        default: {}
      }
    },
    watch:{
      'consulta.id'(){
      },
      'consulta.tipo_status.id'(){
      },
      'formData.senha'(){
        this.config.disabled.obs = (this.formData.senha ? false : true);
      },
    },
    data () {
      return{
        config:{
          tipo:[],
          tipo_exclude:[],
          list:{
          },
					loading:{
						save:false,
					},
					disabled:{
            obs:true,
					}
				},
        response:{
        },
        formData:{
          obs:null,
          senha:null,
        },
        formItems:[],
      }
    },

    created(){
    },
    mounted(){
      this.formItems = FormItems;
    },

    methods: {


      salvar: function(){

				this.$confirm('Ao efetuar o CANCELAMENTO da consulta, não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
				type: 'warning'
				})
				.then(() => {

					this.config.loading.save = true;
					this.response = {};

					this.post('consulta/liberacao/'+this.consulta.id_con+'/cancelar',this.formData).then((result)=>{

						result = result[0];
						this.response = result;

						this.config.loading.save = false;

						if(result.status == 200){
							this.edMsg('Liberação cadastrado com sucesso!');
              this.$events.fire('consulta-liberado');
						}

					});
				});
      }
      
    }
}
</script>



// WEBPACK FOOTER //
// cancelar.vue?27ec8db0